import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty2 from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled from "styled-components";
import Heading from "../Heading";
import Stack from "../Stack";
import { LABEL_SIZES, LABEL_ELEMENTS } from "./consts";
import FormFeedback, { StyledFormFeedback } from "../FormFeedback";
import defaultTheme from "../defaultTheme";
import FilterWrapper from "./components/FilterWrapper";
import randomID from "../utils/randomID";

var getHeadingSize = function getHeadingSize(size) {
  var _SIZES;

  var SIZES = (_SIZES = {}, _defineProperty2(_SIZES, LABEL_SIZES.NORMAL, "title3"), _defineProperty2(_SIZES, LABEL_SIZES.LARGE, "title2"), _SIZES);
  return SIZES[size];
};

var StyledChoiceGroup = styled.div.withConfig({
  displayName: "ChoiceGroup__StyledChoiceGroup",
  componentId: "njp29m-0"
})(["width:100%;display:flex;flex-direction:column;", "{position:relative;margin-top:", ";top:initial;}"], StyledFormFeedback, function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.spaceXSmall;
});
StyledChoiceGroup.defaultProps = {
  theme: defaultTheme
};

var ChoiceGroup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ChoiceGroup, _React$PureComponent);

  function ChoiceGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChoiceGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChoiceGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "groupID", randomID("choiceGroupID"));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (ev) {
      ev.persist();
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(ev);
      }
    });

    return _this;
  }

  _createClass(ChoiceGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataTest = _this$props.dataTest,
          label = _this$props.label,
          _this$props$labelSize = _this$props.labelSize,
          labelSize = _this$props$labelSize === void 0 ? LABEL_SIZES.NORMAL : _this$props$labelSize,
          _this$props$labelAs = _this$props.labelAs,
          labelAs = _this$props$labelAs === void 0 ? LABEL_ELEMENTS.H4 : _this$props$labelAs,
          error = _this$props.error,
          children = _this$props.children,
          filter = _this$props.filter,
          onOnlySelection = _this$props.onOnlySelection;
      return React.createElement(StyledChoiceGroup, {
        "data-test": dataTest,
        role: "group",
        "aria-labelledby": this.groupID
      }, label && React.createElement(Heading, {
        id: this.groupID,
        type: getHeadingSize(labelSize),
        element: labelAs,
        spaceAfter: "medium"
      }, label), React.createElement(Stack, {
        direction: "column",
        spacing: filter ? "none" : "condensed"
      }, React.Children.map(children, function (child) {
        return !filter ? React.createElement(React.Fragment, null, React.cloneElement(child, {
          onChange: _this2.handleChange,
          hasError: !!error
        })) : React.createElement(FilterWrapper, {
          child: child,
          onOnlySelection: onOnlySelection
        }, React.createElement(React.Fragment, null, React.cloneElement(child, {
          onChange: _this2.handleChange,
          hasError: !!error
        })));
      })), error && React.createElement(FormFeedback, {
        type: "error"
      }, error));
    }
  }]);

  return ChoiceGroup;
}(React.PureComponent);

export default ChoiceGroup;